<script setup>
import { storeToRefs } from 'pinia';
import { useStartupApplicationStore } from '@/stores';
import KalioTextAnswer from '@/components/form/kalio-text-answer.vue';
import useFormAnswers from '@/hooks/form_answers.js';

const FORM_ANSWERS_PATHS = [
  'other.techStack',
  'other.ai',
  'other.alternativeIdea',
  'other.finding',
  'other.previousApplication',
  'curious.whyPV',
  'curious.acquisitionChannel',
  'other.referralCode',
];

const startupApplicationStore = useStartupApplicationStore();
const { currentStartupApplication: startupApplication } = storeToRefs(startupApplicationStore);
const { formAnswers } = useFormAnswers(FORM_ANSWERS_PATHS, startupApplication.value);
</script>

<template>
  <div class="flex flex-col space-y-4">
    <kalio-text-answer
      v-for="(item, index) in formAnswers"
      :key="index"
      :label="item.label"
      :answer="item.answer"
    />
  </div>
</template>
